import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from "@mui/material";
import { Helmet } from 'react-helmet';
import './BrainDrain.css';

const BrainDrainArchive = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 20;
  const cdn = "https://files.geetsuhane.com/";

  useEffect(() => {
    const fetchArchive = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_END_POINT}/braindrain/archive?page=${page}&limit=${limit}`
        );
        const data = await response.json();
        setQuestions(data.questions || []);
        setTotal(data.total || 0);
      } catch (err) {
        console.error('Error fetching archive:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchArchive();
  }, [page]);

  const totalPages = Math.ceil(total / limit);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="main-content-wrap">
      <Helmet>
        <title>Brain Drain Archive - Past Riddles & Answers | Geet Suhane</title>
        <meta name="description" content="Browse all past Brain Drain riddles with answers and winners. Fun riddles in Hindi and English on Geet Suhane." />
        <meta name="keywords" content="riddles, brain teasers, Hindi riddles, puzzle games, answers, quiz archive" />
        <meta property="og:title" content="Brain Drain Archive - Past Riddles & Answers" />
        <meta property="og:description" content="Browse all past Brain Drain riddles with answers and winners. Fun riddles in Hindi and English!" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://geetsuhane.com/braindrain/archive" />
      </Helmet>

      <div className="brain-drain-container archive-list-page">
        {/* Header */}
        <div className="brain-drain-header">
          <span className="brain-icon">&#129504;</span>
          <span className="brain-title">Brain Drain Archive</span>
          <span className="brain-icon">&#129504;</span>
        </div>

        {/* Play Now CTA */}
        <div className="play-now-cta">
          <Link to="/braindrain" className="play-btn">
            Play Current Question
          </Link>
        </div>

        {/* Questions List */}
        <div className="archive-list">
          {loading ? (
            <div className="loading-spinner"></div>
          ) : questions.length > 0 ? (
            questions.map((q) => (
              <Link to={`/braindrain/q/${q.id}`} key={q.id} className="archive-item">
                <div className="archive-item-header">
                  <span className="archive-item-id">#{q.id}</span>
                  <span className="archive-item-date">{formatDate(q.used_at)}</span>
                </div>
                <div className="archive-item-question">
                  {q.question_en?.substring(0, 80)}...
                </div>
                <div className="archive-item-footer">
                  <div className="archive-item-answer">
                    Answer: <strong>{q.answer}</strong>
                  </div>
                  {q.winner_name && (
                    <div className="archive-item-winner">
                      <Avatar
                        src={q.winner_picture?.startsWith('http') ? q.winner_picture : cdn + q.winner_picture}
                        alt={q.winner_name}
                        sx={{ width: 20, height: 20 }}
                      />
                      <span>{q.winner_name}</span>
                    </div>
                  )}
                </div>
              </Link>
            ))
          ) : (
            <div className="no-questions">
              No questions answered yet. Be the first to play!
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              className="page-btn"
            >
              Previous
            </button>
            <span className="page-info">
              Page {page} of {totalPages}
            </span>
            <button
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
              className="page-btn"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrainDrainArchive;
